"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registry = exports.CONTRACTS_ADDRESSES = exports.Stablecoin = exports.Collateral = exports.SimpleStrategy = exports.LenderStrategy = exports.BorrowCollateral = exports.AMO = void 0;
const types_1 = require("../types");
const arbitrum_1 = __importDefault(require("./contracts_addresses/arbitrum"));
const aurora_1 = __importDefault(require("./contracts_addresses/aurora"));
const avalanche_1 = __importDefault(require("./contracts_addresses/avalanche"));
const bsc_1 = __importDefault(require("./contracts_addresses/bsc"));
const celo_1 = __importDefault(require("./contracts_addresses/celo"));
const fantom_1 = __importDefault(require("./contracts_addresses/fantom"));
const gnosis_1 = __importDefault(require("./contracts_addresses/gnosis"));
const local_1 = __importDefault(require("./contracts_addresses/local"));
const mainnet_1 = __importDefault(require("./contracts_addresses/mainnet"));
const optimism_1 = __importDefault(require("./contracts_addresses/optimism"));
const polygon_1 = __importDefault(require("./contracts_addresses/polygon"));
const polygonzkevm_1 = __importDefault(require("./contracts_addresses/polygonzkevm"));
var AMO;
(function (AMO) {
    AMO["agEURvEUROC"] = "agEURvEUROC";
})(AMO = exports.AMO || (exports.AMO = {}));
var BorrowCollateral;
(function (BorrowCollateral) {
    BorrowCollateral["LUSD"] = "LUSD";
    BorrowCollateral["bIB01"] = "bIB01";
    BorrowCollateral["bHIGH"] = "bHIGH";
    BorrowCollateral["wBTC"] = "wBTC";
    BorrowCollateral["wETH"] = "wETH";
    BorrowCollateral["wSTETH"] = "wSTETH";
    BorrowCollateral["MAI"] = "MAI";
    BorrowCollateral["cbETH"] = "cbETH";
    BorrowCollateral["USDC"] = "USDC";
    BorrowCollateral["wMATIC"] = "wMATIC";
    BorrowCollateral["OP"] = "OP";
    BorrowCollateral["agstk-am3CRV"] = "agstk-am3CRV";
    BorrowCollateral["wAVAX"] = "wAVAX";
    BorrowCollateral["cvx-crvFRAXUSDC"] = "cvx-crvFRAXUSDC";
    BorrowCollateral["cvx-3CRV"] = "cvx-3CRV";
    BorrowCollateral["cvx-crvLUSD3CRV"] = "cvx-crvLUSD3CRV";
    BorrowCollateral["cvx-crvUSDCUSDT"] = "cvx-crvUSDCUSDT";
    BorrowCollateral["sd-crvFRAXUSDC"] = "sd-crvFRAXUSDC";
    BorrowCollateral["sd-3CRV"] = "sd-3CRV";
    BorrowCollateral["sd-crvLUSD3CRV"] = "sd-crvLUSD3CRV";
    BorrowCollateral["sd-crvUSDCUSDT"] = "sd-crvUSDCUSDT";
})(BorrowCollateral = exports.BorrowCollateral || (exports.BorrowCollateral = {}));
var LenderStrategy;
(function (LenderStrategy) {
    LenderStrategy["GenericOptimisedLender"] = "GenericOptimisedLender";
    LenderStrategy["AaveFlashloan"] = "AaveFlashloan";
})(LenderStrategy = exports.LenderStrategy || (exports.LenderStrategy = {}));
var SimpleStrategy;
(function (SimpleStrategy) {
    SimpleStrategy["StETH"] = "StETH";
})(SimpleStrategy = exports.SimpleStrategy || (exports.SimpleStrategy = {}));
var Collateral;
(function (Collateral) {
    Collateral["DAI"] = "DAI";
    Collateral["FEI"] = "FEI";
    Collateral["FRAX"] = "FRAX";
    Collateral["USDC"] = "USDC";
    Collateral["wETH"] = "wETH";
})(Collateral = exports.Collateral || (exports.Collateral = {}));
var Stablecoin;
(function (Stablecoin) {
    Stablecoin["agEUR"] = "agEUR";
    Stablecoin["agGOLD"] = "agGOLD";
})(Stablecoin = exports.Stablecoin || (exports.Stablecoin = {}));
exports.CONTRACTS_ADDRESSES = {
    [types_1.ChainId.MAINNET]: mainnet_1.default,
    [types_1.ChainId.POLYGON]: polygon_1.default,
    [types_1.ChainId.OPTIMISM]: optimism_1.default,
    [types_1.ChainId.ARBITRUM]: arbitrum_1.default,
    [types_1.ChainId.AVALANCHE]: avalanche_1.default,
    [types_1.ChainId.FANTOM]: fantom_1.default,
    [types_1.ChainId.BSC]: bsc_1.default,
    [types_1.ChainId.AURORA]: aurora_1.default,
    [types_1.ChainId.CELO]: celo_1.default,
    [types_1.ChainId.GNOSIS]: gnosis_1.default,
    [types_1.ChainId.POLYGONZKEVM]: polygonzkevm_1.default,
    [types_1.ChainId.LOCAL]: local_1.default,
};
function registry(chainId, args = null, collateral = null) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    if (!!args && typeof args === 'string' && !!collateral) {
        return registry(chainId, { stablecoin: args, collateral: collateral });
    }
    if (!!args && typeof args === 'string') {
        return registry(chainId, { stablecoin: args });
    }
    if (!!args && typeof args !== 'string' && 'strategy' in args) {
        return (_e = (_d = (_c = (_b = (_a = exports.CONTRACTS_ADDRESSES[chainId]) === null || _a === void 0 ? void 0 : _a[args.stablecoin]) === null || _b === void 0 ? void 0 : _b.collaterals) === null || _c === void 0 ? void 0 : _c[args.collateral]) === null || _d === void 0 ? void 0 : _d.Strategies) === null || _e === void 0 ? void 0 : _e[args.strategy];
    }
    else if (!!args && typeof args !== 'string' && 'lenderStrategy' in args) {
        return (_k = (_j = (_h = (_g = (_f = exports.CONTRACTS_ADDRESSES[chainId]) === null || _f === void 0 ? void 0 : _f[args.stablecoin]) === null || _g === void 0 ? void 0 : _g.collaterals) === null || _h === void 0 ? void 0 : _h[args.collateral]) === null || _j === void 0 ? void 0 : _j.Strategies) === null || _k === void 0 ? void 0 : _k[args.lenderStrategy];
    }
    else if (!!args && typeof args !== 'string' && 'borrowCollateral' in args) {
        return (_o = (_m = (_l = exports.CONTRACTS_ADDRESSES[chainId]) === null || _l === void 0 ? void 0 : _l[args.stablecoin]) === null || _m === void 0 ? void 0 : _m.borrowCollaterals) === null || _o === void 0 ? void 0 : _o[args.borrowCollateral];
    }
    else if (!!args && typeof args !== 'string' && 'collateral' in args) {
        return (_r = (_q = (_p = exports.CONTRACTS_ADDRESSES[chainId]) === null || _p === void 0 ? void 0 : _p[args.stablecoin]) === null || _q === void 0 ? void 0 : _q.collaterals) === null || _r === void 0 ? void 0 : _r[args.collateral];
    }
    else if (!!args && typeof args !== 'string' && 'stablecoin' in args) {
        return (_s = exports.CONTRACTS_ADDRESSES[chainId]) === null || _s === void 0 ? void 0 : _s[args.stablecoin];
    }
    else if (!!args && typeof args !== 'string' && 'amo' in args) {
        return (_v = (_u = (_t = exports.CONTRACTS_ADDRESSES[chainId]) === null || _t === void 0 ? void 0 : _t.AMO) === null || _u === void 0 ? void 0 : _u.BPAMOs) === null || _v === void 0 ? void 0 : _v[args.amo];
    }
    else {
        return exports.CONTRACTS_ADDRESSES[chainId];
    }
}
exports.registry = registry;
//# sourceMappingURL=contracts.js.map